import { createStore, createLogger } from "vuex";
import createPersistedState from "vuex-persistedstate";

// TODO: How to surpass cyclical dependency linting errors cleanly?
import {
  store as auth,
  AuthStore,
  State as AuthState,
} from "@/store/modules/auth";
import {
  store as general,
  GeneralStore,
  State as GeneralState,
} from "@/store/modules/general";
import {
  store as dashboard,
  DashboardStore,
  State as DashboardState,
} from "@/store/modules/dashboard";
import {
  store as alert,
  AlertStore,
  State as AlertState,
} from "@/store/modules/alert";

export type RootState = {
  auth: AuthState;
  general: GeneralState;
  dashboard: DashboardState;
  alert: AlertState;
};

export type Store = AuthStore<Pick<RootState, "auth">> &
  GeneralStore<Pick<RootState, "general">> &
  DashboardStore<Pick<RootState, "dashboard">> &
  AlertStore<Pick<RootState, "alert">>;

// Plug in logger when in development environment
const debug = process.env.NODE_ENV !== "production";
const plugins = debug ? [createLogger({})] : [];

// Plug in session storage based persistence
// plugins.push(createPersistedState({ storage: window.sessionStorage }));

export const store = createStore({
  plugins,
  modules: {
    auth,
    general,
    dashboard,
    alert
  },
});

export function useStore(): Store {
  return store as Store;
}
